import { Alert, Box, Container, Paper, Typography } from "@mui/material";

import Dropzone from "../../../util/ui/dropzone";
import { radius } from "../../../../theme";
import { addDoc } from "firebase/firestore";
import { uploadBytes, ref, getStorage } from "firebase/storage";
import { forEach } from "lodash";
import moment from "moment";
import felixAnalytics from "../../../../felixAnalytics";
import { SituacaoUpload } from "../../../../models/enum";
import { useUsuario } from "../../../../providers/usuarioProvider";
import UploadInternacional from "../../../../models/uploadInternacional";
import UploadInternacionalDb from "../../../../db/uploadInternacionalDb";

export default function UploadStatements() {
  const { visualizado } = useUsuario();

  function onDropAccepted<T extends File>(files: T[]) {
    console.log("Files dropped:", files);

    if (!!visualizado) {
      console.log("Visualizado user:", visualizado);

      const uploadInternacionalCollection =
        new UploadInternacionalDb().collection({
          usuarioId: visualizado,
          uploadId: "",
        });

      forEach(files, (file) => {
        console.log("Processing file:", file.name);

        addDoc(
          uploadInternacionalCollection,
          new UploadInternacional({
            id: "",
            nomeArquivoOriginal: file.name,
            situacao: SituacaoUpload.SALVO,
            dataUpload: moment(),
          })
        )
          .then((doc) => {
            console.log("Document created:", doc.id);

            return uploadBytes(
              ref(
                getStorage(),
                `/usuarios/${visualizado}/uploadsInternacionais/${doc.id}`
              ),
              file,
              { customMetadata: { nome: file.name } }
            ).then(() => {
              console.log("File uploaded successfully");
              felixAnalytics.track("statement_cadastrado", {
                tipo: "statement",
              });
            });
          })
          .catch((error) => {
            console.error("Error during upload:", error);
          });
      });
    } else {
      console.warn("No visualizado user found");
    }
  }

  return (
    <Paper variant="outlined" sx={{ borderRadius: `${radius.xl}px` }}>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="stretch"
          gap={1}
          width="100%"
        >
          <Typography variant="eyebrow" color="text.secondary">
            Mercado Internacional
          </Typography>

          <Alert severity="info">
            1. Cadastre as Operações feitas no Mercado Internacional importando
            os statements
          </Alert>

          <Alert severity="warning" sx={{ mt: 1 }}>
            Por enquanto, somos compatíveis com statements da XP, BTG, Pictet
            Bank, Interactive Brokers e Avenue. Para outras instituições, envie
            um e-mail para suporte@felixnabolsa.com.br.
          </Alert>

          <Box py={2} width="100%">
            <Dropzone onDropAccepted={onDropAccepted} />
          </Box>
        </Box>
      </Container>
    </Paper>
  );
}
